// In SourcesContext.tsx
import React from 'react';
import { SourceEntity } from './SourceEntity';

type SourcesContextType = [SourceEntity[], React.Dispatch<React.SetStateAction<SourceEntity[]>>];

export const SourcesContext = React.createContext<SourcesContextType>([[], () => {}]);
